import { ReactElement } from "react";
import type { GetStaticProps } from "next";
import NextHeadSeo from "next-head-seo";

import LayoutMain from "~/components/layouts/LayoutMain";
import { Header } from "~/components/app/Header";
import {
  restApiGetPostBySlugOrFallbackId,
  restApiESGetSettings,
} from "~/utils/restApi";
import { appConfig } from "~/config";
import { PageSubMenu } from "~/components/ui/PageSubMenu";
import { FlexibleRow } from "~/components/flexibleContent/FlexibleRow";
import { useConfigContext } from "~/providers/ConfigContextProvider";

const WhatsOnCategoryList = ({ currentPage }: { currentPage: any }) => {
  const config = useConfigContext();

  return (
    <>
      <NextHeadSeo
        canonical={currentPage?.yoast_head_json?.canonical}
        title={`${currentPage?.title} - What's On - ${config.appTitle}`}
        description={currentPage?.yoast_head_json?.description}
        og={{
          title: currentPage?.yoast_head_json?.og_title,
          type: currentPage?.yoast_head_json?.og_type,
          siteName: currentPage?.yoast_head_json?.og_site_name,
          image: currentPage?.yoast_head_json?.twitter_image,
        }}
        twitter={{
          card: "summary_large_image",
        }}
      />

      <Header>
        <PageSubMenu
          title={currentPage?.title}
          menu={currentPage?.subMenu?.menu}
        />
      </Header>
      <main id="content">
        {currentPage?.acf?.content?.length > 0 && (
          <FlexibleRow field="content" content={currentPage.acf.content} />
        )}
      </main>
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const token = (context?.previewData as any)?.token;

  const currentPage = await restApiGetPostBySlugOrFallbackId(
    "page",
    "3d-visit",
    token
  );

  const frontendSettings = await restApiESGetSettings(["programmeCategory"]);
  return {
    props: {
      frontendSettings,
      currentPage,
    },
    revalidate: frontendSettings?.options?.copyrightNotice
      ? appConfig.revalidateInterval("exhibitionListing")
      : 15,
  };
};

WhatsOnCategoryList.getLayout = function getLayout(page: ReactElement) {
  return <LayoutMain>{page}</LayoutMain>;
};
export default WhatsOnCategoryList;
